import { makeStyles } from '@mui/styles';
import { neutral7 } from 'apollo-react/colors';
import React from 'react';
import { useSelector } from 'react-redux';

import { useTranslation } from '../../custom-hooks/useTranslation';
import NewControl from '../components/NewControl';
import { REPORT_CONTROL_TYPE } from '../constants/report-designer.constants';
import DynamicControl from '../DynamicControl';
import { getEntityFieldsTranslation } from '../selectors/report-designer.selectors';
import { translateEntityField } from '../utils/report-designer.utils';

const useStyles = makeStyles({
  root: {
    border: `1px solid ${neutral7}`,
    borderRadius: 5,
  },
  groupHeader: {
    display: 'flex',
    justifyContent: 'center',
    padding: 10,
    borderBottom: `1px solid ${neutral7}`,
  },
  groupTitle: {
    fontWeight: 500,
  },
  childrenContainer: {
    padding: 8,
    display: 'flex',
    flexWrap: 'wrap',
    minHeight: 50,
  },
});

const SSGroupHeader = ({ childrenNodes, groupByColumn = '', id }) => {
  const classes = useStyles();
  const translateString = useTranslation();

  const entityTranslation = useSelector(getEntityFieldsTranslation);

  const groupTitleToDisplay = groupByColumn.startsWith('eval||')
    ? translateString('Expression')
    : translateEntityField(entityTranslation, groupByColumn) || translateString('Title');

  return (
    <div className={classes.root}>
      <div className={classes.groupHeader}>
        <span>{translateString('Group:')} </span>&nbsp;
        <span className={classes.groupTitle}>{groupTitleToDisplay}</span>
      </div>
      <div className={classes.childrenContainer}>
        {childrenNodes.map((childId) => (
          <DynamicControl key={childId} id={childId} />
        ))}
        <NewControl parentId={id} controlType={REPORT_CONTROL_TYPE.GROUP_TREND} />
      </div>
    </div>
  );
};

export default SSGroupHeader;
